import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DARK_ACCORDION } from '@yme/atoms/accordion';
import { Col, Container, Row } from '@yme/atoms/grid-old';
import { VerticalMenu } from '@yme/atoms/vertical-menu';
import { SocialIcons } from '@yme/components/Footer/SocialIcons';
import { useWindowSize } from '@yme/hooks/index';
import { FooterComponent, Heading } from '@yme/molecules/footer';
import { getIsNewsletterSubscriptionEnabled } from '@yme/selectors/common';
import { getRTL } from '@yme/selectors/index';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel3 } from '@yme/tokens/typography';
import { DigitalDataMutation, buildKey, setDigitalData } from '@yme/utils/common';
import { Newsletters } from './Newsletters';
import { setNewsletterInterests } from './Newsletters/redux/actions';
import { getNavigationItem } from './helpers';
import { setFooterLabels, setSocialLinks } from './redux/actions';
import { AccordionStyled, MobileWrapperStyled } from './styled';
export default function Footer(props) {
    const { columns, labels, socialLinks, newsletter } = props;
    const { isInfiniteDesktopView } = useWindowSize();
    const dispatch = useDispatch();
    const isRightToLeft = useSelector(getRTL);
    const isNewsletterSubscriptionEnabled = useSelector(getIsNewsletterSubscriptionEnabled);
    useEffect(() => {
        if (labels) {
            dispatch(setFooterLabels(labels));
        }
        if (socialLinks) {
            dispatch(setSocialLinks(socialLinks));
        }
        if (newsletter?.interests) {
            dispatch(setNewsletterInterests(newsletter.interests));
        }
    }, [dispatch, labels, newsletter, socialLinks]);
    const accordionData = useMemo(() => columns.map(({ tabTitle, links }, index) => {
        const onClick = (title) => {
            return (link) => {
                setDigitalData(DigitalDataMutation.NAVIGATION, {
                    pageSection: 'footer',
                    navigationGroup: title,
                    navigationItem: link.linkTitleMaster || getNavigationItem(link.link),
                });
            };
        };
        const children = (React.createElement(VerticalMenu, { links: links, onClick: onClick(tabTitle), isRightToLeft: isRightToLeft, key: buildKey(tabTitle, `${links}_${index}`) }));
        return {
            title: React.createElement(HeadingLevel3, { color: colorCoreWhite1000 }, tabTitle),
            children,
            isRightToLeft,
        };
    }), [columns, isRightToLeft]);
    return (React.createElement(FooterComponent, { isRightToLeft: isRightToLeft },
        React.createElement(Container, { xxlPadding: "48px 48px 0 48px" }, isInfiniteDesktopView ? (React.createElement(Row, null,
            columns.map(({ tabTitle, links }, index) => {
                const onClick = (title) => {
                    return (link) => {
                        setDigitalData(DigitalDataMutation.NAVIGATION, {
                            pageSection: 'footer',
                            navigationGroup: title,
                            navigationItem: link.linkTitleMaster || getNavigationItem(link.link),
                        });
                    };
                };
                return (React.createElement(Col, { xxl: 2, key: buildKey(tabTitle, index) },
                    React.createElement(Heading, null, tabTitle),
                    React.createElement(VerticalMenu, { links: links, onClick: onClick(tabTitle), isRightToLeft: isRightToLeft })));
            }),
            React.createElement(Col, { xxl: 4, lg: 12, sm: 12 },
                isNewsletterSubscriptionEnabled ? (React.createElement(Newsletters, null)) : (React.createElement(Heading, null, labels?.footerMenu_newsletterSocials_title)),
                isInfiniteDesktopView ? (React.createElement(FlexWrapper, { justifyContent: isNewsletterSubscriptionEnabled ? 'flex-end' : 'flex-start', alignItems: "flex-start", pt: "8px" },
                    React.createElement(SocialIcons, { socialLinks: socialLinks }))) : null))) : (React.createElement(MobileWrapperStyled, null,
            React.createElement(AccordionStyled, { isRightToLeft: isRightToLeft, data: accordionData, colorScheme: DARK_ACCORDION, hasContainerPadding: false }))))));
}
Footer.displayName = 'Footer_AEMComponent';
